import React from "react";
import "./commonBlock.css";

export default function PartnerBox({ imgObj }) {
  return (
    <div className="partnerBox">
      {imgObj.imageUrl && <img src={imgObj.imageUrl} alt="logo" />}
    </div>
  );
}
